import { createFileRoute } from "@tanstack/react-router";
import { AccountSignOut } from "@/features/account";
import {
  resolveRedirectUrl,
  returnSearchSchema,
} from "@/features/identity/navigation";

export const Route = createFileRoute("/_site/account/sign-out")({
  validateSearch: returnSearchSchema,
  head: () => ({
    meta: [
      { title: "Sign out | Softmax" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: SignOutRoute,
});

function SignOutRoute() {
  const { redirect_url } = Route.useSearch();
  return (
    <div className="mx-auto max-w-lg px-4 py-16">
      <AccountSignOut callbackUrl={resolveRedirectUrl(redirect_url ?? "/")} />
    </div>
  );
}
